import {api} from './index';
import type {ExportForm} from "../pages/private/Export/Export";

export async function getExport(request: ExportForm): Promise<{ blob: Blob; filename: string }> {
  const response = await api.post('/Export/report', request, { responseType: 'blob' });

  // Try to extract filename from Content-Disposition header
  const cd = (response.headers?.['content-disposition'] || response.headers?.['Content-Disposition']) as string | undefined;
  let filename = `export-report-${request.startDate ?? ''}_${request.endDate ?? ''}.xlsx`;
  if (cd) {
    const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
    const raw = decodeURIComponent(match?.[1] || match?.[2] || '');
    if (raw) filename = raw;
  }

  return { blob: response.data as Blob, filename };
}
